import { render } from "./FooterLinks.vue?vue&type=template&id=4de63fec&scoped=true"
import script from "./FooterLinks.vue?vue&type=script&lang=js"
export * from "./FooterLinks.vue?vue&type=script&lang=js"

import "./FooterLinks.vue?vue&type=style&index=0&id=4de63fec&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4de63fec"

export default script